/// <reference path="../types/index.d.ts" />

import '../client_forms/goretti/style.css';
import FormStructure from './goretti/form_structure';

export default FormStructure;